import {
  Box,
  Flex,
  Heading,
  SimpleGrid,
  Stat,
  StatLabel,
  StatNumber,
  useColorModeValue,
  useTheme,
} from "@chakra-ui/react";
import React, { useMemo } from "react";
import { useParams } from "react-router-dom";
import HybridBottomSheetDrawer from "../../components/HybridBottomSheetDrawer";
import QueryStateWrapper from "../../components/QueryStateWrapper";
import { useLaundrette } from "../../data/laundrette.api";
import { useFocusOnFeature } from "../../hooks/useFocusOnFeature";
import { Feature } from "geojson";
import LaundryMachine from "../../components/laundrette/LaundryMachine";
import BackButton from "../../components/BackButton";
import FavouriteButton from "../../components/FavouriteButton";
import { usePC } from "../../data/pcs.api";

type Props = {};

const ViewPC = (props: Props) => {
  const { id } = useParams<{ id: string }>();
  const { data, isLoading, error } = usePC(id);
  const bg = useColorModeValue("lancsBlue.50", "gray.800");
  const theme = useTheme();

  const feature = useMemo((): Feature | undefined => {
    if (data) {
      return {
        type: "Feature",
        properties: {},
        geometry: {
          type: "Point",
          coordinates: [data.Longitude, data.Latitude],
        },
      };
    }
  }, [data]);

  const pointOptions = useMemo(() => {
    return {
      color: data?.Available
        ? theme?.colors?.["green"]?.["500"]
        : theme?.colors?.["lancsRed"]?.["300"],
    };
  }, [data, theme?.colors]);

  useFocusOnFeature(feature, 17.5, pointOptions);

  return (
    <HybridBottomSheetDrawer>
      <BackButton />
      <Box p={8}>
        <QueryStateWrapper isLoading={isLoading} error={error} data={data}>
          <Flex justify="space-between">
            <Heading size="md" mb={4} textTransform="capitalize">
              {data?.Label}
            </Heading>
            <FavouriteButton name={`${data?.Label}`} />
          </Flex>
          <Flex bg={bg} p={5} rounded="md" boxShadow="sm" mb={5}>
            <Stat>
              <StatLabel>PCs Available</StatLabel>
              <StatNumber>{data?.Available ?? 0}</StatNumber>
            </Stat>
            <Stat>
              <StatLabel>PCs In Use</StatLabel>
              <StatNumber>{data?.InUse ?? 0}</StatNumber>
            </Stat>
          </Flex>
        </QueryStateWrapper>
      </Box>
    </HybridBottomSheetDrawer>
  );
};

export default ViewPC;
